import { ReactNode, useEffect, useRef, useState } from "react";
import Column from "../Column";
import Title from "../Title";
import styles from "./AppDropdownMultiple.module.scss";
import { Select, SelectProps } from "antd";
import Row from "../Row";

interface AppInputDropdownMultipleProps<DataType> extends SelectProps {
  orientation?: "col" | "row";
  isSubTable?: boolean;
  infoTooltip?: ReactNode;
  currentValue?: DataType[];
  onChangeValue?: (value: DataType[]) => void;
  onLabelAction?: () => void;
  errorText?: string;
  label?: string;
  isRequired?: boolean;
}

function AppInputDropdownMultiple<DataType>(props: AppInputDropdownMultipleProps<DataType>) {
  const {
    errorText,
    label,
    currentValue,
    onChangeValue,
    orientation = "row",
    options = [],
    isRequired,
    isSubTable = false,
    infoTooltip,
    onLabelAction,
    ...rest
  } = props;

  const parent = useRef<HTMLDivElement>(null);

  const Wrap = orientation === "row" ? Row : Column;

  return (
    <Column className={`gap-1 w-100`}>
      <Wrap className="w-100" ref={parent}>
        {label && <Title isRequired={isRequired} label={label} />}
        <div className="w-100 ">
          <Select
            mode="multiple"
            value={currentValue}
            onChange={(e) => {
              onChangeValue?.(e);
            }}
            className={`w-100 ${styles.appMultiSelected}`}
            status={errorText ? "error" : ""}
            options={options}
            maxTagCount={"responsive"}
            filterOption={(input, option) => {
              if (option?.label) {
                return (option.label as string)?.toLowerCase().includes(input.toLowerCase());
              }
              return false;
            }}
            {...rest}
          />
        </div>
      </Wrap>

      {errorText && (
        <small className="text-error pb-1" style={isSubTable || !label ? {} : { marginLeft: 120 }}>
          {errorText}
        </small>
      )}
    </Column>
  );
}

export default AppInputDropdownMultiple;
